import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    value: 1,
}

export const FactorStateSlice = createSlice({
    name: 'factorStep',
    initialState,
    reducers: {
        factorState: (state, action) => {
            state.value =  action.payload;
        },
        
    },
})

export const {factorState} = FactorStateSlice.actions

export default FactorStateSlice.reducer 